/**
 * Safranwunder storefront — global UI
 */
(function () {
  'use strict';

  function isWeekend(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }

  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var remaining = Math.max(parseInt(days || '0', 10), 0);

    if (remaining === 0 && isWeekend(result)) {
      while (isWeekend(result)) {
        result.setDate(result.getDate() + 1);
      }
      return result;
    }

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (!isWeekend(result)) {
        remaining -= 1;
      }
    }

    return result;
  }

  function initDeliveryEstimates() {
    document.querySelectorAll('[data-sw-delivery-estimate]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-offset-days') || '2', 10);
      var lang = document.documentElement.lang || 'de-DE';
      // Outside the German storefront parcels go international (3–6 business days): use the upper bound and show the date
      var intl = lang.toLowerCase().indexOf('de') !== 0;
      if (intl) days += 4;
      var d = addBusinessDays(new Date(), days);
      try {
        el.textContent = d.toLocaleDateString(lang, intl ? { weekday: 'long', day: 'numeric', month: 'long' } : { weekday: 'long' });
      } catch (e) {
        el.textContent = d.toLocaleDateString('de-DE', { weekday: 'long' });
      }
    });
  }

  /** Prefer template SW announcement over header duplicate (see .sw-header-group + sw-base.css). */
  function getSwAnnouncementEl() {
    var main = document.getElementById('MainContent');
    if (main) {
      var inMain = main.querySelector('.sw-announcement');
      if (inMain) return inMain;
    }
    return document.querySelector('.sw-announcement');
  }

  /** SW announcement inside #MainContent (template) — used with header-group overrides in CSS. */
  function syncSwAnnouncementInMainClass() {
    var root = document.documentElement;
    var main = document.getElementById('MainContent');
    if (main && main.querySelector('.sw-announcement')) {
      root.classList.add('sw-announcement-in-main');
    } else {
      root.classList.remove('sw-announcement-in-main');
    }
  }

  /**
   * When SW Announcement is the first section in #MainContent, enable flow layout above the fixed
   * header (see sw-base.css). Reorder in the theme editor if it is not first.
   */
  function syncSwAnnouncementPinTopClass() {
    var main = document.getElementById('MainContent');
    var root = document.documentElement;
    if (!main) return;
    main.querySelectorAll('.shopify-section--sw-announcement-pinned').forEach(function (el) {
      el.classList.remove('shopify-section--sw-announcement-pinned');
    });
    root.classList.remove('sw-announcement-pin-top');
    var first = main.firstElementChild;
    if (
      first &&
      first.classList.contains('shopify-section') &&
      first.classList.contains('section-sw-announcement')
    ) {
      root.classList.add('sw-announcement-pin-top');
      first.classList.add('shopify-section--sw-announcement-pinned');
    }
  }

  /** Mobile nav drawer is fixed; offset top when SW announcement is still in the viewport */
  function initNavDrawerAnnouncementSync() {
    syncSwAnnouncementInMainClass();
    syncSwAnnouncementPinTopClass();
    var ann = getSwAnnouncementEl();
    var root = document.documentElement;
    if (!ann) return;
    root.classList.add('sw-has-announcement');
    function setInView(isIntersecting) {
      root.classList.toggle('sw-announcement-in-view', isIntersecting);
    }
    function annInViewport() {
      var r = ann.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }
    setInView(annInViewport());
    var io = new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        if (e) setInView(e.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px' }
    );
    io.observe(ann);
  }

  function initHeader() {
    var header = document.querySelector('[data-sw-header]');
    var toggle = document.querySelector('[data-sw-nav-toggle]');
    var drawer = document.querySelector('[data-sw-nav-drawer]');
    if (!toggle || !drawer) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.hidden = !open;
      document.body.classList.toggle('sw-nav-open', open);
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        setOpen(false);
      });
    });

    if (header) {
      window.addEventListener(
        'scroll',
        function () {
          header.classList.toggle('sw-header--scrolled', window.scrollY > 10);
        },
        { passive: true }
      );
    }
  }

  function initAccordions(scope) {
    var root = scope || document;
    root.querySelectorAll('.sw-acc-item__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.sw-acc-item');
        if (!item) return;
        var panel = item.querySelector('.sw-acc-item__panel');
        var open = item.classList.toggle('sw-acc-item--open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
    });
  }

  function initViewerCount() {
    document.querySelectorAll('[data-sw-viewer-count]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-sw-min') || '38', 10);
      var max = parseInt(el.getAttribute('data-sw-max') || '62', 10);
      if (min >= max) return;

      // Start at a random value within the range
      var current = min + Math.floor(Math.random() * (max - min + 1));
      el.textContent = current;

      function tick() {
        // Pick step size: 1 most of the time, occasionally 2
        var step = Math.random() < 0.25 ? 2 : 1;
        // Direction: random, but clamp to stay inside [min, max]
        var dir = Math.random() < 0.5 ? 1 : -1;
        if (current <= min) dir = 1;
        if (current >= max) dir = -1;

        var next = Math.min(max, Math.max(min, current + dir * step));

        // Fade out → update number → fade in
        el.classList.add('sw-vc--fade');
        setTimeout(function () {
          current = next;
          el.textContent = current;
          el.classList.remove('sw-vc--fade');
        }, 130);

        // Schedule next tick: 3–8 s
        setTimeout(tick, 3000 + Math.floor(Math.random() * 5000));
      }

      // First tick after 4–9 s so it doesn't fire immediately on load
      setTimeout(tick, 4000 + Math.floor(Math.random() * 5000));
    });
  }

  function initPdpGallery() {
    var mainImg = document.getElementById('swPdpMainImg');
    if (!mainImg) return;

    var track = document.querySelector('.sw-pdp-thumbs');
    var btnPrev = document.querySelector('.sw-pdp-thumb-arrow--prev');
    var btnNext = document.querySelector('.sw-pdp-thumb-arrow--next');

    function updateArrows() {
      if (!track) return;
      if (btnPrev) btnPrev.disabled = track.scrollLeft <= 2;
      if (btnNext) btnNext.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
    }

    function scrollBy(dir) {
      if (!track) return;
      var thumbWidth = track.querySelector('.sw-pdp-thumb');
      var step = thumbWidth ? (thumbWidth.offsetWidth + 8) * 4 : track.offsetWidth;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { scrollBy(-1); });
    if (btnNext) btnNext.addEventListener('click', function () { scrollBy(1); });
    if (track) track.addEventListener('scroll', updateArrows, { passive: true });

    updateArrows();

    document.querySelectorAll('.sw-pdp-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (src) mainImg.src = src;
        document.querySelectorAll('.sw-pdp-thumb').forEach(function (t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');
      });
    });
  }

  function initVariantPicker() {
    function syncAtcVariantFromInput(input) {
      if (!input || !input.checked) return;
      var container = input.closest('.product__info-container');
      if (!container) return;
      var mirror = container.querySelector('[data-sw-atc-mirror-rcard]');
      if (mirror) {
        var cta =
          input.closest('.sw-vp-rcard') &&
          input.closest('.sw-vp-rcard').querySelector('.sw-vp-rcard__cta');
        if (cta) mirror.textContent = cta.textContent.trim();
        return;
      }
      var atcVariantLabel = container.querySelector('[data-sw-atc-variant]');
      if (!atcVariantLabel) return;
      var wrap = input.closest('.sw-vp__card, .sw-vp-chip, .sw-vp-rcard');
      if (!wrap) return;
      var titleEl =
        wrap.querySelector('.sw-vp__weight') ||
        wrap.querySelector('.sw-vp-chip__title') ||
        wrap.querySelector('.sw-vp-rcard__title');
      if (titleEl) atcVariantLabel.textContent = titleEl.textContent.trim();
    }

    document
      .querySelectorAll(
        '.product__info-container .sw-vp-rcards, .product__info-container .sw-vp-chips, .product__info-container [data-sw-vp-grid]'
      )
      .forEach(function (host) {
        host.addEventListener('change', function (e) {
          if (!e.target.classList || !e.target.classList.contains('sw-vp__input')) return;
          syncAtcVariantFromInput(e.target);
        });
        var checked = host.querySelector('.sw-vp__input:checked:not(:disabled)');
        if (checked) syncAtcVariantFromInput(checked);
      });
  }

  function syncSwAnnouncementLayoutClasses() {
    syncSwAnnouncementInMainClass();
    syncSwAnnouncementPinTopClass();
  }

  document.addEventListener('shopify:section:load', syncSwAnnouncementLayoutClasses);
  document.addEventListener('shopify:section:unload', syncSwAnnouncementLayoutClasses);

  document.addEventListener('DOMContentLoaded', function () {
    initDeliveryEstimates();
    initNavDrawerAnnouncementSync();
    initHeader();
    initAccordions();
    initViewerCount();
    initPdpGallery();
    initVariantPicker();
  });

  window.swInitAccordions = initAccordions;
})();
